import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=40b6a8dd&scoped=true&lang=pug&"
import script from "./SettingsComponent.vue?vue&type=script&lang=ts&"
export * from "./SettingsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=40b6a8dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b6a8dd",
  null
  
)

export default component.exports